(function (Drupal, once) {
  Drupal.behaviors.oneTrustButton = {
    attach(context) {
      once('onetrust-button', '#ot-sdk-btn', context).forEach((button) => {
        button.removeAttribute('onmouseover');
        button.removeAttribute('onmouseout');
      });
    },
  };
})(Drupal, once);
